import React, { useState, useEffect } from "react";

interface ResendOtpProps {
  onResend: (type: string) => void; // Accepts a string argument
  maxResendAttempts: number;
}

const ResendOtpButton: React.FC<ResendOtpProps> = ({ onResend, maxResendAttempts }) => {
  const [timeLeft, setTimeLeft] = useState<number>(120); // Countdown timer in seconds
  const [resendAttempts, setResendAttempts] = useState<number>(0);

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setInterval(() => setTimeLeft((prev) => prev - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [timeLeft]);

  const handleResend = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (resendAttempts < maxResendAttempts) {
      onResend('otp');
      setTimeLeft(120); // Reset the timer after sending OTP
      setResendAttempts((prev) => prev + 1); // Increment resend attempts
    }
  };

  return (
    <div className="mt-4">
      <p className="text-gray-600">
        {resendAttempts >= maxResendAttempts ? '' : 'Didn’t receive OTP? '}
        <button
          type="button"
          className={`ml-2 text-p_primary ${(resendAttempts >= maxResendAttempts || timeLeft > 0) ? '' : 'cursor-pointer'}` }
          onClick={handleResend}
          disabled={resendAttempts >= maxResendAttempts || timeLeft > 0}
        >
          {resendAttempts >= maxResendAttempts ? 
          'Resend limit exceeded'
          :timeLeft > 0 ? (
            `Resend in ${Math.floor(timeLeft / 60)}:${timeLeft % 60 < 10 ? "0" : ""}${timeLeft % 60}`
          ) : (
            "Resend"
          )}
        </button>
      </p>
    </div>
  );
};

export default ResendOtpButton;
